import axios from 'axios';

const httpService = axios.create();

httpService.interceptors.response.use(undefined, (error) => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  if (!expectedError && error.response.status === 503) window.location.href = '/home/maintenance';
  else if (!expectedError && error.response.status === 500) window.location.href = '/home/server-error';

  return Promise.reject(error);
});

const service = {
  get: httpService.get,
  post: httpService.post,
  put: httpService.put,
  patch: httpService.patch,
  delete: httpService.delete,
};

export default service;
